import { t } from "@/i18n-js/instance";

export const CHAT_NOTIFICATION_TYPES_OPTIONS = [
  {
    value: "all",
    get label() {
      return t("notification_settings.all.label");
    },
    get description() {
      return t("notification_settings.all.description");
    },
  },
  {
    value: "mentions",
    get label() {
      return t("notification_settings.mentions.label");
    },
    get description() {
      return t("notification_settings.mentions.description");
    },
  },
  {
    value: "never",
    get label() {
      return t("notification_settings.never.label");
    },
    get description() {
      return t("notification_settings.never.description");
    },
  },
];

export const CHAT_NOTIFICATION_TYPES_MEMBER_OPTIONS = [
  {
    value: "all",
    get label() {
      return t("member_notification_settings.all.label");
    },
    get description() {
      return t("member_notification_settings.all.description");
    },
  },
  {
    value: "mentions",
    get label() {
      return t("member_notification_settings.mentions.label");
    },
    get description() {
      return t("member_notification_settings.mentions.description");
    },
  },
  {
    value: "never",
    get label() {
      return t("member_notification_settings.never.label");
    },
    get description() {
      return t("member_notification_settings.never.description");
    },
  },
];
